import React from 'react';
import { Loader, EmptyListMessage } from 'components';
import { Pagination } from 'components';
import { Link } from 'react-router-dom';
import { utcStringToLocalDate } from 'common';

const PaperworkEntryList = ({
    loading,
    items,
    pageNumber,
    pageSize,
    totalRecordCount,
    onPageChange,
    onChecboxChange
}) => {
    if (loading) {
        return <Loader />
    }

    if (!items || items.length === 0) {
        return <EmptyListMessage message={"There are no paperwork entry items..."} />
    }

    return (
        <div>    
            <table className="table table--fixed spc--bottom--sml">
                <thead className="table__head">
                    <tr className="table__head__row">
                        <th className="table__head__data">
                            <a href="javascript:void(0);">Created By</a>
                        </th>
                        <th className="table__head__data">
                            <a href="javascript:void(0);">Client</a>
                        </th>
                        <th className="table__head__data">
                            <a href="javascript:void(0);">Patient</a>
                        </th>
                        <th className="table__head__data">
                            <a href="javascript:void(0);">Status</a>
                        </th>     
                        <th className="table__head__data">
                            <a href="javascript:void(0);">Date Of Service</a>
                        </th>
                        <th className="table__head__data">
                            <a href="javascript:void(0);">Date Created</a>
                        </th>
                        <th className="table__head__data">
                            Options
                        </th>
                        <th className="table__head__data type--center w--1">
                            Print
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {
                        items.map(item => {
                            return <EntryListItem key={item.id} item={item} onChecboxChange={onChecboxChange}/>
                        })
                    }
                </tbody>
            </table>
            <Pagination pageNumber={pageNumber} pageSize={pageSize} totalRecordCount={totalRecordCount} onChange={onPageChange} />
        </div>
    )
}

const EntryListItem = ({ item, onChecboxChange }) => {
    return (
        <tr className="table__body__row">
            <td className="table__body__data">
                <span>{getFullName(item.user)}</span>
            </td>
            <td className="table__body__data">
                <span>{item.client.name}</span>
            </td>
            <td className="table__body__data">
                <span>{getFullName(item)}</span>
            </td>
            <td className="table__body__data">
                <span>{item.paperworkStatus.description}</span>
            </td>
            <td className="table__body__data">
                <span>{utcStringToLocalDate(item.dos)}</span>
            </td>
            <td className="table__body__data">
                <span>{utcStringToLocalDate(item.createdOn)}</span>
            </td>
            <td className="table__body__data">
                <Link to={`/paperworks/${item.id}`} className="nav-link">
                    Details
                </Link>               
            </td>
            <td className="type--center table__body__data">
                <input id={item.id} className="input--check input--check--table" type="checkbox" checked={item.selectedForPrint || false} onChange={(e) => onChecboxChange(e, item)} />
                <label htmlFor={item.id}></label>
            </td>
        </tr>
    );
}

function getFullName(user) {
    if (user.fullName) {
        return user.fullName;
    }
    else if (user.firstName && user.lastName) {
        return `${user.firstName} ${user.lastName}`;
    }

    return user.username;
}

export { PaperworkEntryList }


// WEBPACK FOOTER //
// ./src/modules/paperwork-entry/components/PaperworkEntryList.js